module.exports = {
	"links": [
		{
			"display": "Github",
			"url": "https://github.com/rrichardsonv"
		},
		{
			"display": "LinkedIn",
			"url": "https://linkedin.com/in/rrichardsonv"
		},
		{
			"display": "Twitter",
			"url": "https://twitter.com/riposteMkV"
		}
	],
	"infoProps": {
		"title": "contact",
		"image": "contacts_civtile.png",
		"pos": "0px 0px"
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/contacts.json
// module id = 133
// module chunks = 0